import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";
import {
    FiBookmark,
    FiBell,
    FiFilter,
    FiTrendingUp,
    FiTrendingDown,
    FiCalendar,
    FiClock,
    FiUser,
    FiArrowRight,
    FiDownload,
    FiLock,
    FiUnlock,
    FiStar,
} from "react-icons/fi";

// Format date
const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

// Format time
const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
    });
};

export default function CallsFeed() {
    const [subscriptionPlan, setSubscriptionPlan] = useState("free"); // free, basic, premium
    const [selectedFilter, setSelectedFilter] = useState("all"); // all, buy, sell, hold
    const [bookmarkedCalls, setBookmarkedCalls] = useState([]);
    const [alertedCalls, setAlertedCalls] = useState([]);

    // Static Data - Research Calls
    const researchCalls = [
        {
            id: 1,
            title: "Buy Recommendation: Reliance Industries",
            type: "Buy",
            stock: "Reliance Industries",
            targetPrice: 2850,
            currentPrice: 2650,
            stopLoss: 2550,
            analyst: "Senior Equity Analyst",
            date: "2024-01-15T10:30:00",
            category: "Large Cap",
            isPremium: false,
            updates: [
                { date: "2024-01-15T10:30:00", note: "Initial call issued" },
                { date: "2024-01-16T14:20:00", note: "Price target maintained" },
            ],
        },
        {
            id: 2,
            title: "Sell Recommendation: Tech Mahindra",
            type: "Sell",
            stock: "Tech Mahindra",
            targetPrice: 1200,
            currentPrice: 1350,
            stopLoss: 1400,
            analyst: "Technology Sector Analyst",
            date: "2024-01-14T09:15:00",
            category: "Mid Cap",
            isPremium: true,
            updates: [
                { date: "2024-01-14T09:15:00", note: "Initial call issued" },
                { date: "2024-01-15T11:00:00", note: "Stop loss updated" },
            ],
        },
        {
            id: 3,
            title: "Hold Recommendation: HDFC Bank",
            type: "Hold",
            stock: "HDFC Bank",
            targetPrice: 1650,
            currentPrice: 1620,
            stopLoss: 1580,
            analyst: "Banking Sector Analyst",
            date: "2024-01-13T15:45:00",
            category: "Large Cap",
            isPremium: false,
            updates: [
                { date: "2024-01-13T15:45:00", note: "Initial call issued" },
            ],
        },
        {
            id: 4,
            title: "Buy Recommendation: Infosys",
            type: "Buy",
            stock: "Infosys",
            targetPrice: 1850,
            currentPrice: 1720,
            stopLoss: 1680,
            analyst: "IT Services Analyst",
            date: "2024-01-12T11:20:00",
            category: "Large Cap",
            isPremium: true,
            updates: [
                { date: "2024-01-12T11:20:00", note: "Initial call issued" },
                { date: "2024-01-13T16:30:00", note: "Target price revised upward" },
            ],
        },
        {
            id: 5,
            title: "Sell Recommendation: Zomato",
            type: "Sell",
            stock: "Zomato",
            targetPrice: 85,
            currentPrice: 95,
            stopLoss: 100,
            analyst: "Consumer Services Analyst",
            date: "2024-01-11T13:10:00",
            category: "Mid Cap",
            isPremium: true,
            updates: [
                { date: "2024-01-11T13:10:00", note: "Initial call issued" },
            ],
        },
    ];

    const canAccessContent = (isPremium) => {
        if (!isPremium) return true;
        return subscriptionPlan !== "free";
    };

    const handleBookmark = (callId) => {
        if (bookmarkedCalls.includes(callId)) {
            setBookmarkedCalls(bookmarkedCalls.filter((id) => id !== callId));
        } else {
            setBookmarkedCalls([...bookmarkedCalls, callId]);
        }
    };

    const handleSetAlert = (callId) => {
        if (alertedCalls.includes(callId)) {
            setAlertedCalls(alertedCalls.filter((id) => id !== callId));
        } else {
            setAlertedCalls([...alertedCalls, callId]);
        }
    };

    const handleOpenCall = (call) => {
        if (call.isPremium && !canAccessContent(call.isPremium)) {
            alert("This call requires a premium subscription. Please upgrade your plan.");
            return;
        }
        alert(`Opening call detail: ${call.title}`);
    };

    const filteredCalls =
        selectedFilter === "all"
            ? researchCalls
            : researchCalls.filter((call) => call.type.toLowerCase() === selectedFilter.toLowerCase());

    const getPriceChange = (current, target) => {
        const change = ((target - current) / current) * 100;
        return change.toFixed(2);
    };

    return (
        <>
            <ClientNavbar />
            <div className="page-content" style={{ background: "#f8fafc" }}>
            <style>{`
                .call-card {
                    transition: all 0.3s ease;
                    border: 1px solid #e9ecef;
                }
                .call-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(0,0,0,0.1) !important;
                    border-color: #1bafb4;
                }
                .filter-button {
                    transition: all 0.2s ease;
                    border-radius: 8px;
                }
                .filter-button:hover {
                    background-color: #f1f5f9;
                }
            `}</style>
                    {/* Header */}
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                        <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div>


                                    <h3 className="text-primary mb-2">Calls Feed</h3>

                                    <nav
                                        aria-label="breadcrumb"
                                        style={{ "--bs-breadcrumb-divider": "none" }}
                                    >
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <NavLink to="/overview">Dashboard</NavLink> /
                                            </li>
                                            <li className="breadcrumb-item">

                                                <NavLink to="/overview">Research Analysis</NavLink> /
                                            </li>
                                            <li className="breadcrumb-item active">Calls Feed</li>
                                        </ol>
                                    </nav>

                                </div>
                                <div className="d-flex gap-2 align-items-center flex-wrap mt-2">
                                    {subscriptionPlan === "free" && (
                                        <button
                                            className="btn btn-primary btn-sm fw-semibold"
                                            onClick={() => window.location.href = "/research/plans-billing"}
                                            style={{ borderRadius: "8px" }}
                                        >
                                            {/* <FiStar className="me-1" /> */}
                                            Upgrade Plan
                                        </button>
                                    )}
                                    <span
                                        className={`badge px-3 py-2 fw-semibold ${subscriptionPlan === "free"
                                            ? "bg-secondary"
                                            : subscriptionPlan === "basic"
                                                ? "bg-info"
                                                : "bg-success"
                                            }`}
                                        style={{ fontSize: "12px" }}
                                    >
                                        {subscriptionPlan === "free"
                                            ? "Free Plan"
                                            : subscriptionPlan === "basic"
                                                ? "Basic Plan"
                                                : "Premium Plan"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
                        <div
                            className="card-header border-0 py-3 px-4"
                            style={{ background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)" }}
                        >
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <div className="d-flex align-items-center">
                                    <div
                                        className="me-3 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "10px",
                                            background: "#c8eeecbf",
                                        }}
                                    >
                                        <FiFilter style={{ color: "#39b2b4", fontSize: "20px" }} />
                                    </div>
                                    <h6 className="mb-0 fw-bold text-dark">Filter Calls</h6>
                                </div>
                                <div className="d-flex align-items-center gap-3 mt-2 mt-md-0">
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="badge bg-light text-dark px-3 py-2 fw-semibold" style={{ fontSize: "12px" }}>
                                            {filteredCalls.length} {filteredCalls.length === 1 ? "Call" : "Calls"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                {["all", "buy", "sell", "hold"].map((filter) => {
                                    const isActive = selectedFilter === filter;
                                    const filterConfig = {
                                        all: {
                                            active: "linear-gradient(135deg, #1bafb4 0%, #06b6a4 100%)",
                                            inactive: "#ffffff",
                                            icon: "📊",
                                            label: "All Calls",
                                            borderColor: "#1bafb4",
                                        },
                                        buy: {
                                            active: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                            inactive: "#ffffff",
                                            icon: "📈",
                                            label: "Buy",
                                            borderColor: "#10b981",
                                        },
                                        sell: {
                                            active: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                                            inactive: "#ffffff",
                                            icon: "📉",
                                            label: "Sell",
                                            borderColor: "#ef4444",
                                        },
                                        hold: {
                                            active: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                                            inactive: "#ffffff",
                                            icon: "⏸️",
                                            label: "Hold",
                                            borderColor: "#f59e0b",
                                        },
                                    };
                                    const config = filterConfig[filter] || filterConfig.all;

                                    return (
                                        <button
                                            key={filter}
                                            className="btn fw-semibold position-relative"
                                            onClick={() => setSelectedFilter(filter)}
                                            style={{
                                                borderRadius: "12px",
                                                textTransform: "capitalize",
                                                padding: "12px 24px",
                                                fontSize: "14px",
                                                border: isActive ? "none" : `2px solid ${config.borderColor}40`,
                                                background: isActive ? config.active : config.inactive,
                                                color: isActive ? "white" : "#475569",
                                                boxShadow: isActive
                                                    ? `0 4px 12px ${config.borderColor}40`
                                                    : "0 2px 4px rgba(0,0,0,0.05)",
                                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                                minWidth: "100px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!isActive) {
                                                    e.currentTarget.style.transform = "translateY(-2px)";
                                                    e.currentTarget.style.boxShadow = `0 4px 12px ${config.borderColor}30`;
                                                    e.currentTarget.style.borderColor = config.borderColor;
                                                    e.currentTarget.style.background = `${config.borderColor}08`;
                                                } else {
                                                    e.currentTarget.style.transform = "translateY(-1px)";
                                                    e.currentTarget.style.boxShadow = `0 6px 16px ${config.borderColor}50`;
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                if (!isActive) {
                                                    e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
                                                    e.currentTarget.style.borderColor = `${config.borderColor}40`;
                                                    e.currentTarget.style.background = config.inactive;
                                                } else {
                                                    e.currentTarget.style.boxShadow = `0 4px 12px ${config.borderColor}40`;
                                                }
                                            }}
                                        >
                                            <span style={{ fontSize: "16px", lineHeight: "1" }}>
                                                {config.icon}
                                            </span>
                                            <span>{config.label}</span>
                                            {isActive && (
                                                <span
                                                    className="position-absolute top-0 end-0"
                                                    style={{
                                                        width: "8px",
                                                        height: "8px",
                                                        borderRadius: "50%",
                                                        background: "rgba(255,255,255,0.9)",
                                                        margin: "4px",
                                                        boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                                    }}
                                                />
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Subscription Warning */}
                    {subscriptionPlan === "free" && (
                        <div
                            className="alert mb-4 border-0"
                            style={{
                                borderRadius: "12px",
                                backgroundColor: "#ccf1f7",
                                borderColor: "#b3eaf4",
                                border: "1px solid #b3eaf4",
                                color: "#006e82",
                            }}
                        >
                            <div className="d-flex align-items-start">
                                <FiLock className="me-3 mt-1" style={{ fontSize: "24px", color: "#006e82" }} />
                                <div className="flex-grow-1">
                                    <strong style={{ fontSize: "16px", color: "#006e82" }}>
                                        Premium Calls Limited
                                    </strong>
                                    <div className="mt-2" style={{ fontSize: "14px", color: "#006e82", opacity: 0.9 }}>
                                        Upgrade your plan to access all premium research calls and unlimited downloads.
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Calls Feed */}
                    <div className="row g-4">
                        {filteredCalls.map((call) => {
                            const isLocked = call.isPremium && !canAccessContent(call.isPremium);
                            const isBookmarked = bookmarkedCalls.includes(call.id);
                            const hasAlert = alertedCalls.includes(call.id);
                            const priceChange = getPriceChange(call.currentPrice, call.targetPrice);
                            const isPositive = call.type === "Buy" ? priceChange > 0 : priceChange < 0;

                            // Badge colors based on call type
                            const badgeColors = {
                                Buy: { bg: "#10b981", color: "white" },
                                Sell: { bg: "#ef4444", color: "white" },
                                Hold: { bg: "#f59e0b", color: "white" },
                            };
                            const badgeColor = badgeColors[call.type] || badgeColors.Buy;

                            return (
                                <div key={call.id} className="col-12">
                                    <div
                                        className="card call-card border-0 shadow-sm"
                                        style={{
                                            borderRadius: "12px",
                                            opacity: isLocked ? 0.85 : 1,
                                            border: "1px solid #e9ecef",
                                        }}
                                    >
                                        <div className="card-body p-4">
                                            {/* Header Section */}
                                            <div className="d-flex justify-content-between align-items-start mb-4">
                                                <div className="flex-grow-1">
                                                    {/* Badges */}
                                                    <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                                        <span
                                                            className="badge px-3 py-2 fw-bold"
                                                            style={{
                                                                fontSize: "12px",
                                                                backgroundColor: badgeColor.bg,
                                                                color: badgeColor.color,
                                                                borderRadius: "6px",
                                                            }}
                                                        >
                                                            {call.type}
                                                        </span>
                                                        <span
                                                            className="badge px-3 py-2 fw-bold"
                                                            style={{
                                                                fontSize: "12px",
                                                                backgroundColor: "#39b2b4",
                                                                color: "white",
                                                                borderRadius: "6px",
                                                            }}
                                                        >
                                                            {call.category}
                                                        </span>
                                                        {call.isPremium && (
                                                            <span
                                                                className="badge px-3 py-2 fw-bold"
                                                                style={{
                                                                    background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
                                                                    fontSize: "11px",
                                                                    color: "white",
                                                                    borderRadius: "6px",
                                                                }}
                                                            >
                                                                {isLocked ? (
                                                                    <>
                                                                        {/* <FiLock className="me-1" style={{ fontSize: "10px" }} /> */}
                                                                        Premium
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FiUnlock className="me-1" style={{ fontSize: "10px" }} />
                                                                        Premium
                                                                    </>
                                                                )}
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Title */}
                                                    <h5
                                                        className="mb-3 fw-bold"
                                                        style={{ fontSize: "20px", color: "#006e82", lineHeight: "1.4" }}
                                                    >
                                                        {call.title}
                                                    </h5>

                                                    {/* Metadata */}
                                                    <div className="d-flex align-items-center gap-4 flex-wrap">
                                                        <div className="d-flex align-items-center" style={{ color: "#64748b" }}>
                                                            <FiUser className="me-2" style={{ fontSize: "16px", color: "#94a3b8" }} />
                                                            <small style={{ fontSize: "13px" }}>{call.analyst}</small>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ color: "#64748b" }}>
                                                            <FiCalendar className="me-2" style={{ fontSize: "16px", color: "#94a3b8" }} />
                                                            <small style={{ fontSize: "13px" }}>{formatDate(call.date)}</small>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ color: "#64748b" }}>
                                                            <FiClock className="me-2" style={{ fontSize: "16px", color: "#94a3b8" }} />
                                                            <small style={{ fontSize: "13px" }}>{formatTime(call.date)}</small>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Action Buttons */}
                                                <div className="d-flex gap-2 ms-3">
                                                    <button
                                                        className={`btn btn-sm ${isBookmarked ? "btn-warning" : "btn-outline-secondary"}`}
                                                        onClick={() => handleBookmark(call.id)}
                                                        title="Bookmark"
                                                        style={{
                                                            borderRadius: "8px",
                                                            width: "40px",
                                                            height: "40px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            padding: 0,
                                                        }}
                                                    >
                                                        <FiBookmark style={{ fontSize: "18px" }} />
                                                    </button>
                                                    <button
                                                        className={`btn btn-sm ${hasAlert ? "btn-primary" : "btn-outline-primary"}`}
                                                        onClick={() => handleSetAlert(call.id)}
                                                        title="Set Alert"
                                                        style={{
                                                            borderRadius: "8px",
                                                            width: "40px",
                                                            height: "40px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            padding: 0,
                                                        }}
                                                    >
                                                        <FiBell style={{ fontSize: "18px" }} />
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Price Information */}
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-3 col-sm-6">
                                                    <div
                                                        className="p-3 rounded"
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderRadius: "10px",
                                                            border: "1px solid #b3eaf4",
                                                        }}
                                                    >
                                                        <div className="small mb-2" style={{ color: "#64748b", fontSize: "12px" }}>
                                                            Current Price
                                                        </div>
                                                        <div className="h5 mb-0 fw-bold" style={{ color: "#006e82", fontSize: "20px" }}>
                                                            ₹{call.currentPrice.toLocaleString("en-IN")}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-sm-6">
                                                    <div
                                                        className="p-3 rounded"
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderRadius: "10px",
                                                            border: "1px solid #b3eaf4",
                                                        }}
                                                    >
                                                        <div className="small mb-2" style={{ color: "#64748b", fontSize: "12px" }}>
                                                            Target Price
                                                        </div>
                                                        <div className="h5 mb-0 fw-bold" style={{ color: "#006e82", fontSize: "20px" }}>
                                                            ₹{call.targetPrice.toLocaleString("en-IN")}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-sm-6">
                                                    <div
                                                        className="p-3 rounded"
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderRadius: "10px",
                                                            border: "1px solid #b3eaf4",
                                                        }}
                                                    >
                                                        <div className="small mb-2" style={{ color: "#64748b", fontSize: "12px" }}>
                                                            Stop Loss
                                                        </div>
                                                        <div className="h5 mb-0 fw-bold" style={{ color: "#ef4444", fontSize: "20px" }}>
                                                            ₹{call.stopLoss.toLocaleString("en-IN")}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-sm-6">
                                                    <div
                                                        className="p-3 rounded"
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderRadius: "10px",
                                                            border: "1px solid #b3eaf4",
                                                        }}
                                                    >
                                                        <div className="small mb-2" style={{ color: "#64748b", fontSize: "12px" }}>
                                                            Potential
                                                        </div>
                                                        <div
                                                            className={`h5 mb-0 fw-bold d-flex align-items-center ${isPositive ? "text-success" : "text-danger"
                                                                }`}
                                                            style={{ fontSize: "20px" }}
                                                        >
                                                            {isPositive ? (
                                                                <FiTrendingUp className="me-2" style={{ fontSize: "20px" }} />
                                                            ) : (
                                                                <FiTrendingDown className="me-2" style={{ fontSize: "20px" }} />
                                                            )}
                                                            {Math.abs(priceChange)}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Update Timeline */}
                                            {call.updates && call.updates.length > 0 && (
                                                <div className="mb-4">
                                                    <h6 className="fw-bold mb-3" style={{ fontSize: "15px", color: "#006e82" }}>
                                                        Update Timeline:
                                                    </h6>
                                                    <div className="timeline">
                                                        {call.updates.map((update, index) => (
                                                            <div key={index} className="d-flex align-items-start mb-3">
                                                                <div
                                                                    className="d-flex align-items-center justify-content-center me-3"
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",
                                                                        borderRadius: "50%",
                                                                        background: "#ccf1f7",
                                                                        border: "2px solid #b3eaf4",
                                                                        minWidth: "40px",
                                                                        flexShrink: 0,
                                                                    }}
                                                                >
                                                                    <FiClock style={{ color: "#006e82", fontSize: "18px" }} />
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="fw-bold mb-1" style={{ fontSize: "13px", color: "#334155" }}>
                                                                        {formatDate(update.date)} at {formatTime(update.date)}
                                                                    </div>
                                                                    <div style={{ fontSize: "13px", color: "#64748b" }}>{update.note}</div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Actions */}
                                            <div className="d-flex gap-2 mt-4 pt-3 border-top">
                                                {isLocked ? (
                                                    <button
                                                        className="btn btn-warning fw-semibold"
                                                        onClick={() => window.location.href = "/research/plans-billing"}
                                                        style={{
                                                            borderRadius: "10px",
                                                            padding: "10px 20px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {/* <FiLock className="me-2" /> */}
                                                        Unlock with Premium
                                                    </button>
                                                ) : (
                                                    <>
                                                        <button
                                                            className="btn fw-semibold"
                                                            onClick={() => handleOpenCall(call)}
                                                            style={{
                                                                borderRadius: "10px",
                                                                padding: "10px 20px",
                                                                fontSize: "14px",
                                                                backgroundColor: badgeColor.bg,
                                                                color: "white",
                                                                border: "none",
                                                            }}
                                                        >
                                                            Open Call Detail
                                                            {/* <FiArrowRight className="ms-2" /> */}
                                                        </button>
                                                        <button
                                                            className="btn btn-outline-primary fw-semibold"
                                                            title="Download"
                                                            style={{
                                                                borderRadius: "10px",
                                                                padding: "10px 20px",
                                                                fontSize: "14px",
                                                                borderColor: "#39b2b4",
                                                                color: "#fff",
                                                            }}
                                                        >
                                                            <FiDownload />
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Rate Limit Notice */}
                    {subscriptionPlan === "free" && (
                        <div className="alert alert-info mt-4 border-0" style={{ borderRadius: "12px" }}>
                            <div className="d-flex align-items-start">
                                <FiLock className="me-2 mt-1" style={{ fontSize: "20px" }} />
                                <div>
                                    <strong>Download Limit</strong>
                                    <div className="small mt-1">
                                        Free plan users have a rate limit on downloads. Upgrade to unlock unlimited downloads.
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
           
            </div>
        </>
    );
}
